import { cn } from "@newxsystems/shared";
import { DaylightAction } from "../DaylightAction/DaylightAction";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div className="relative flex min-h-[38rem] overflow-hidden rounded-[28px] bg-ink md:min-h-[46rem]">
      <DaylightMedia
        className="absolute inset-0 h-full rounded-none"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1440px, calc(100vw - 48px)"
      />
      <div className="absolute inset-0 bg-linear-to-t from-ink/85 via-ink/30 to-transparent" />
      <div className="relative z-10 flex w-full items-end p-5 md:p-10 lg:p-14">
        <div
          className={cn(
            "w-full max-w-[58rem] border-t border-daylight/60 pt-7 text-daylight md:pt-9",
            centered && "mx-auto text-center",
          )}
        >
          <div className={cn("flex flex-col gap-5", centered && "items-center")}>
            {eyebrow ? (
              <p className="flex items-center gap-3 font-daylight-body text-sm font-semibold before:h-px before:w-8 before:bg-current">
                {eyebrow}
              </p>
            ) : null}
            {heading ? (
              <h1 className="max-w-[12ch] break-words font-daylight-display text-[clamp(3rem,7vw,5.125rem)] font-semibold leading-[0.98] tracking-[-0.035em] text-balance">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <DaylightRichText className="max-w-[60ch] text-mineral-gray" content={description} />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <DaylightAction
                    action={button}
                    className="border-mineral-gray text-mineral-gray"
                    key={`${button.href}-${index}`}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
